//React
import React from "react";

//UI
import { Button as AntDButton } from "antd";

//CSS
import "./styles/button.css";

const Button = (props) => {
  return <AntDButton className="custom-button" {...props} />;
};

const ButtonLink = (props) => {
  return (
    <AntDButton
      type="link"
      className="custom-button-link"
      style={{
        color: "#20467f",
      }}
      {...props}
    />
  );
};

const ButtonPrimary = (props) => {
  return (
    <AntDButton
      type="primary"
      className="custom-button custom-button-primary"
      {...props}
    />
  );
};

export { Button, ButtonLink, ButtonPrimary };
